import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Menu } from 'lucide-react';
import Sidebar from './Sidebar';
import { useBranding } from '../context/BrandingContext';
import { useTheme } from '../context/ThemeContext';

const SIDEBAR_KEY = 'farisx_sidebar';

export default function Layout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  // Sidebar desktop recolhível (persistida entre sessões)
  const [collapsed, setCollapsed] = useState(
    () => localStorage.getItem(SIDEBAR_KEY) === 'collapsed',
  );
  const { clientName, logoSrc } = useBranding();
  const { resolved } = useTheme();

  function toggleCollapsed(next: boolean) {
    setCollapsed(next);
    try {
      localStorage.setItem(SIDEBAR_KEY, next ? 'collapsed' : 'open');
    } catch {
      /* quota — ignora */
    }
  }

  return (
    <div className={`${resolved} flex h-screen bg-canvas text-fg`}>
      {/* Sidebar desktop */}
      {!collapsed && (
        <aside className="hidden md:flex w-64 flex-col bg-surface border-r border-line">
          <Sidebar onCollapse={() => toggleCollapsed(true)} />
        </aside>
      )}

      {/* Botão hambúrguer flutuante quando recolhida (desktop) */}
      {collapsed && (
        <button
          onClick={() => toggleCollapsed(false)}
          className="hidden md:flex fixed top-3 left-3 z-40 w-10 h-10 rounded-xl bg-surface border border-line hover:bg-hover items-center justify-center text-fg-2 shadow-lg transition"
          aria-label="Mostrar menu"
        >
          <Menu size={20} />
        </button>
      )}

      {/* Drawer mobile */}
      {mobileOpen && (
        <>
          <div
            className="fixed inset-0 z-40 bg-black/60 md:hidden"
            onClick={() => setMobileOpen(false)}
          />
          <aside className="fixed inset-y-0 left-0 z-50 w-64 bg-surface border-r border-line flex flex-col md:hidden">
            <Sidebar onNavigate={() => setMobileOpen(false)} />
          </aside>
        </>
      )}

      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Topbar mobile */}
        <header className="md:hidden flex items-center justify-between px-4 py-3 bg-surface border-b border-line">
          <button
            onClick={() => setMobileOpen(true)}
            className="w-10 h-10 rounded-lg bg-hover flex items-center justify-center"
            aria-label="Abrir menu"
          >
            <Menu size={20} />
          </button>
          <div className="flex items-center gap-2 min-w-0">
            {logoSrc ? (
              <img
                src={logoSrc}
                alt={clientName}
                className="h-10 w-auto max-w-[3rem] object-contain flex-shrink-0"
              />
            ) : (
              <div className="w-9 h-9 rounded-lg bg-primary-solid flex items-center justify-center font-bold flex-shrink-0">
                {clientName.charAt(0).toUpperCase()}
              </div>
            )}
            <span className="font-bold truncate">{clientName}</span>
          </div>
          <div className="w-10" /> {/* spacer pra centralizar logo */}
        </header>

        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
